import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'soundx724_cookie_consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-secondary-900 text-white shadow-2xl border-t-2 border-primary-400">
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="flex-1 text-sm text-secondary-200 leading-relaxed">
          We use cookies to improve your experience on SoundX724, including essential cookies for site functionality and analytics to understand how visitors use our site.
          By clicking <strong className="text-white">Accept</strong>, you agree to our use of cookies.{' '}
          <a
            href="/privacy"
            className="underline text-primary-300 hover:text-primary-100 transition-colors"
          >
            Privacy Policy
          </a>
          {' '}·{' '}
          <a
            href="https://www.cookiesandyou.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-primary-300 hover:text-primary-100 transition-colors"
          >
            Learn more about cookies
          </a>
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={decline}
            className="px-4 py-2 text-sm rounded-lg border border-secondary-500 text-secondary-300 hover:bg-secondary-700 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="px-5 py-2 text-sm rounded-lg bg-primary-500 hover:bg-primary-400 text-white font-semibold transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
